import { useContext } from "react";
import { useQuery } from "react-query";
import { ApiContext } from "../contexts/ApiContext";
import { ResultAssetAndCaptureIds } from "../shared/interfaces/Result";

export function useGetReportingMeasurements(
  customerId: number,
  resultAssetAndCaptureIdList: ResultAssetAndCaptureIds[] | undefined,
) {
  const apiContext = useContext(ApiContext);

  return useQuery({
    queryKey: ["getReportingMeasurements", customerId, resultAssetAndCaptureIdList],
    queryFn: async () => {
      return (
        resultAssetAndCaptureIdList &&
        apiContext.utp2ReportsAPIs
          .getReportMeasurementSelections(customerId, resultAssetAndCaptureIdList)
          .then((response) => {
            return response;
          })
      );
    },
  });
}
